import React from 'react';

import { CheckmarkOutline, Plus } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseButton, Typography } from '@lyearn/ui';

import { tagButtonStyles } from './styles';

interface TagButtonProps {
  name: string;
  isSelected?: boolean;
  className?: string;
  onClick?: (event: any) => void;
}

function TagButton({ name, isSelected, className, onClick }: TagButtonProps) {
  return (
    <BaseButton
      className={cn(
        className,
        tagButtonStyles,
        'flex items-center rounded-24 border border-solid border-border py-4 pe-12 ps-8',
        isSelected
          ? 'bg-interactive-primary hover:bg-interactive-primary-hover active:bg-interactive-primary-active'
          : 'hover:bg-s-info-light active:bg-divider',
      )}
      onClick={onClick}>
      {isSelected ? (
        <CheckmarkOutline className="h-20 w-20 fill-current text-icon-white me-4" />
      ) : (
        <Plus className="h-20 w-20 fill-current text-icon-placeholder me-4" />
      )}
      <Typography
        color={isSelected ? 'text-text-white' : 'text-text-secondary'}
        variant="body-short-02">
        {name}
      </Typography>
    </BaseButton>
  );
}

export default TagButton;
